// extracted by mini-css-extract-plugin
module.exports = {"column":"DashboardScreen_column__2QwfS","link":"DashboardScreen_link__2lf6z","icon":"DashboardScreen_icon__3Juty"};